import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ToastBodyComponent, ToastComponent, ToasterComponent } from "@coreui/angular";
import { TranslateModule } from "@ngx-translate/core";
import { I18nService } from "./core/i18n.service";
import { ToastService } from "./core/toast.service";

@Component({
  selector: "sb-root",
  standalone: true,
  imports: [CommonModule, RouterOutlet, ToasterComponent, ToastComponent, ToastBodyComponent, TranslateModule],
  template: `
    <main class="app-main">
      <router-outlet></router-outlet>

      <c-toaster placement="bottom-end" position="fixed">
        <c-toast
          *ngFor="let toast of toasts$ | async"
          [visible]="true"
          [autohide]="false"
          [color]="toast.kind === 'success' ? 'success' : toast.kind === 'error' ? 'danger' : 'info'"
          class="text-white border-0"
        >
          <c-toast-body class="d-flex align-items-center justify-content-between gap-2">
            <span>{{ toast.text }}</span>
            <button type="button" class="btn btn-sm btn-outline-light" (click)="dismiss(toast.id)">Cerrar</button>
          </c-toast-body>
        </c-toast>
      </c-toaster>
    </main>
  `,
  styles: [
    `
      .app-main {
        min-height: 100vh;
      }
    `
  ]
})
export class AppComponent {
  private readonly toast = inject(ToastService);
  private readonly i18n = inject(I18nService);
  readonly toasts$ = this.toast.toasts$;

  constructor() {
    this.i18n.init();
  }

  dismiss(id: number): void {
    this.toast.dismiss(id);
  }
}
